export const UNIT_1_4_TITLE = 'Units 1-4'
export const BHU_TITLE = 'Recognizing Bullying and Harassment Unit'
